import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import Quotes from '../../../public/assets/Quotes.png';

export default function TestimonialCard({ testimonial, isActive = false, isSide = false }) {
  const containerClasses = `bg-white ${
    isActive ? 'shadow-sm md:shadow-custom-lg' : ''
  } ${isSide ? 'opacity-60' : 'opacity-100'} transition-opacity`;
  return (
    <div
      className={`flex flex-col md:flex-row gap-[24px] sm:gap-[27px] md:gap-[30px] w-full h-full rounded-[20px] px-[16px] sm:px-[18px] md:px-[20px] py-[16px] sm:py-[18px] md:py-[20px] ${containerClasses}`}
    >
      <div className="relative w-[59%] md:w-[43%] self-center">
        <Image
          src={testimonial?.image}
          alt={testimonial?.name}
          className="w-full h-[145px] rounded-[10px]"
          width={400}
          height={350}
        />
      </div>

      <div className="flex flex-col w-full">
        <Image src={Quotes} alt="Quote" className="w-[28px] sm:w-[32px] md:w-[36px] h-[20px] sm:h-[23px] md:h-[26px] self-end" width={100} height={100} />
        <p
          className={`text-[12px] sm:text-[13px] md:text-[14px]  font-normal text-[#202020] mt-3 line-clamp-3 md:line-clamp-6 ${isActive ? 'text-justify pr-[6px] sm:pr-[7px] md:pr-[8px]' : 'text-left'} leading-[20px] sm:leading-[23px] md:leading-[26px]`}
        >
          {testimonial?.message}
        </p>

        <div className="flex flex-col gap-[3px] sm:gap-[3.5px] md:gap-[4px] mt-[14px] md:mt-[18px]">
          <h4 className="text-[14px] sm:text-[15px] md:text-[16px]  font-semibold text-[#202020] uppercase leading-[20px] sm:leading-[22px] md:leading-[24px]">
            {testimonial?.name}
          </h4>
          {testimonial?.designation && (
            <p className="text-[12px] sm:text-[13px] md:text-[14px] font-mulish text-[#808080] leading-[15px] sm:leading-[16px] md:leading-[18px]">
              {testimonial?.designation}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

TestimonialCard.propTypes = {
  testimonial: PropTypes.object,
  isActive: PropTypes.bool,
  isSide: PropTypes.bool,
};
